import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import Header from 'components/Header';
import Footer from 'components/Footer';

type LayoutProps = {
	children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ 
      top: 0,
      behavior: "smooth"
    });
  }, [location.pathname])

  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  )
}

export default Layout